/* ==========================================================================
   Popup Trigg — standalone modal logic
   Handles: open/close, delay/manual triggers, display limits via localStorage,
   overlay click, ESC close, body scroll lock.
   ========================================================================== */

(function () {
  function PopupTrigg(el) {
    this.el = el;
    this.id = el.dataset.id;
    this.overlay = document.querySelector('.popup-trigg__overlay[data-id="' + this.id + '"]');
    this.trigger = el.dataset.trigger || 'delay';
    this.delay = parseInt(el.dataset.delay, 10) || 0;
    this.manualSelector = el.dataset.manualSelector || '';
    this.limitDisplay = parseInt(el.dataset.limitDisplay, 10) || 0;
    this.limitCacheDays = parseInt(el.dataset.limitCache, 10) || 30;
    this.overlayClose = el.dataset.overlayClose === 'true';
    this.escClose = el.dataset.escClose === 'true';
    this.scrollLock = el.dataset.scrollLock === 'true';
    this.storageKey = 'popup-trigg:' + this.id;
    this.init();
  }

  PopupTrigg.prototype.init = function () {
    var self = this;

    // Bind close button
    var closeBtn = this.el.querySelector('.popup-trigg__close');
    if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });

    // Bind overlay click
    if (this.overlay && this.overlayClose) {
      this.overlay.addEventListener('click', function () { self.close(); });
    }

    // Bind ESC
    if (this.escClose) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
    }

    // Trigger
    if (this.trigger === 'manual' && this.manualSelector) {
      var triggers = document.querySelectorAll(this.manualSelector);
      triggers.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          self.open(true); // bypass limit on manual open
        });
      });
    } else {
      // delay trigger
      if (!this.shouldShow()) return;
      setTimeout(function () { self.open(); }, self.delay * 1000);
    }
  };

  PopupTrigg.prototype.shouldShow = function () {
    if (this.limitDisplay <= 0) return true;
    try {
      var raw = localStorage.getItem(this.storageKey);
      if (!raw) return true;
      var data = JSON.parse(raw);
      var now = Date.now();
      if (data.expires && data.expires < now) {
        localStorage.removeItem(this.storageKey);
        return true;
      }
      return (data.count || 0) < this.limitDisplay;
    } catch (e) {
      return true;
    }
  };

  PopupTrigg.prototype.recordDisplay = function () {
    if (this.limitDisplay <= 0) return;
    try {
      var raw = localStorage.getItem(this.storageKey);
      var data = raw ? JSON.parse(raw) : { count: 0 };
      data.count = (data.count || 0) + 1;
      data.expires = Date.now() + this.limitCacheDays * 86400000;
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    } catch (e) {
      /* ignore */
    }
  };

  PopupTrigg.prototype.open = function (bypassLimit) {
    if (!bypassLimit && !this.shouldShow()) return;
    this.el.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-open');
    if (this.scrollLock) document.body.classList.add('popup-trigg-open');
    this.recordDisplay();
  };

  PopupTrigg.prototype.close = function () {
    this.el.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-open');
    document.body.classList.remove('popup-trigg-open');
  };

  function init() {
    var popups = document.querySelectorAll('.popup-trigg[data-id]');
    popups.forEach(function (p) { new PopupTrigg(p); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
